<script lang="ts">
  import { fade, scale } from 'svelte/transition';
  import { onMount } from 'svelte';

  export let isVisible = false;
  let showAnimation = false;

  onMount(() => {
    if (isVisible) {
      setTimeout(() => {
        showAnimation = true;
      }, 100);
    }
  });
</script>

{#if isVisible}
  <div class="sold-out-overlay" in:fade={{ duration: 800 }}>
    <div class="sold-out-container">
      <!-- Cross strike effect -->
      <div class="cross-strike horizontal" class:animate={showAnimation}></div>
      <div class="cross-strike vertical" class:animate={showAnimation}></div>
      
      <!-- Main sold out text -->
      {#if showAnimation}
        <div class="sold-out-text" in:scale={{ duration: 600, start: 0.3 }}>
          <h1>SOLD OUT</h1>
          <p>All tickets have been claimed!</p>
          <div class="emoji-rain">
            🎫🎫🎫🎫🎫
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .sold-out-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    backdrop-filter: blur(5px);
  }

  .sold-out-container {
    position: relative;
    text-align: center;
    color: white;
  }

  .cross-strike {
    position: absolute;
    background: #ff4444;
    transform-origin: center;
  }

  .cross-strike.horizontal {
    width: 0;
    height: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(15deg);
    transition: width 1s ease-out 0.3s;
  }

  .cross-strike.vertical {
    width: 8px;
    height: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-15deg);
    transition: height 1s ease-out 0.6s;
  }

  .cross-strike.animate.horizontal {
    width: 400px;
  }

  .cross-strike.animate.vertical {
    height: 300px;
  }

  .sold-out-text {
    padding: 2rem;
  }

  .sold-out-text h1 {
    font-size: 4rem;
    font-weight: 900;
    margin: 0;
    text-shadow: 3px 3px 6px rgba(255, 68, 68, 0.8);
    animation: pulse 2s infinite;
    color: #ff4444;
  }

  .sold-out-text p {
    font-size: 1.5rem;
    margin: 1rem 0;
    opacity: 0.9;
  }

  .emoji-rain {
    font-size: 2rem;
    animation: bounce 1s infinite alternate;
    margin-top: 1rem;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }

  @keyframes bounce {
    0% { transform: translateY(0); }
    100% { transform: translateY(-10px); }
  }

  @media (max-width: 768px) {
    .sold-out-text h1 {
      font-size: 2.5rem;
    }
    
    .cross-strike.animate.horizontal {
      width: 300px;
    }

    .cross-strike.animate.vertical {
      height: 200px;
    }
  }
</style> 